export default __webpack_public_path__ + "static/media/icon-reschedule-light.1309c5b9.svg";